import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import ImageFullBig from './theme/icons/fullscreen-big.svg';
import ImageFullCancel from './theme/icons/fullscreen-cancel.svg';
import './theme/css/style.css';

export default class FullScreen extends Plugin {
    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add( 'fullScreen', locale => {
            const view = new ButtonView( locale );
            let etat = 0; //si 0 position normale
            view.set( {
                label: '全螢幕編輯模式',
                icon: ImageFullBig,
                tooltip: true
            } );

            // Callback executed once the image is clicked.
            view.on( 'execute', () => {
                if(etat == 1 ){
                    editor.sourceElement.nextElementSibling.removeAttribute('id');
                    document.body.removeAttribute('id');
                    view.set( {
                        label: '全螢幕編輯模式',
                        icon: ImageFullBig,
                        tooltip: true
                    } );
                    etat = 0;
                }
                else
                {
                    editor.sourceElement.nextElementSibling.setAttribute("id", 'fullscreeneditor');
                    document.body.setAttribute("id", "fullscreenoverlay");
                    view.set( {
                        label: '正常編輯模式',
                        icon: ImageFullCancel,
                        tooltip: true
                    } );
                    etat = 1;
                }
            
            } );

            return view;
        } );
    }
}
